import React, { useState } from 'react';

const shortcuts = [
  { keys: '1–7', description: 'Switch timeframe' },
  { keys: 'Tab / ⇧Tab', description: 'Cycle chart categories' },
  { keys: 'Esc', description: 'Unlock chart · close palette' },
  { keys: '⌘K', description: 'Open command palette' },
];

export default function ShortcutHelpPopover() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="btn"
        style={{ padding: '4px 10px', fontSize: 11 }}
        aria-label="Keyboard shortcuts"
        aria-expanded={isOpen}
      >
        ?
      </button>
      {isOpen && (
        <div
          className="panel"
          role="dialog"
          style={{
            position: 'absolute',
            right: 0,
            top: 'calc(100% + 6px)',
            padding: '12px 14px',
            zIndex: 50,
            minWidth: 240,
          }}
        >
          <div
            className="tab-sm muted"
            style={{ fontSize: 9.5, letterSpacing: '0.12em', marginBottom: 10 }}
          >
            § KEYBOARD SHORTCUTS
          </div>
          <ul
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 6,
              listStyle: 'none',
            }}
          >
            {shortcuts.map((s) => (
              <li
                key={s.keys}
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  justifyContent: 'space-between',
                  gap: 12,
                  fontSize: 11,
                }}
              >
                <span className="kbd">{s.keys}</span>
                <span className="muted" style={{ fontFamily: 'var(--mono)' }}>
                  {s.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
